import { render, staticRenderFns } from "./ProcessStage.vue?vue&type=template&id=c070b626&scoped=true&lang=pug&"
import script from "./ProcessStage.vue?vue&type=script&lang=js&"
export * from "./ProcessStage.vue?vue&type=script&lang=js&"
import style0 from "./ProcessStage.vue?vue&type=style&index=0&id=c070b626&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c070b626",
  null
  
)

export default component.exports